import { useState, useEffect, useMemo } from "react";
import { listenCollectionData } from "../services/listeners";
import useAuth from "./use-auth";

const useFirebaseData = (collectionName, queryList = null) => {
  const [collectionData, setCollectionData] = useState(null);
  const [isDataFetching, setIsDataFetching] = useState(true);
  const { user } = useAuth();
  const queryKey = useMemo(() => JSON.stringify(queryList || []), [queryList]);

  useEffect(() => {
    if (!user) {
      setIsDataFetching(false);
      setCollectionData(null);
      return;
    }

    setIsDataFetching(true);
    let listener = null;
    listener = listenCollectionData(
      collectionName,
      (fetchedData) => {
        setCollectionData(fetchedData);
        setIsDataFetching(false);
      },
      queryList
    );

    return () => {
      if (listener) listener();
    };
    // queryKey keeps equivalent query arrays from resubscribing on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionName, queryKey, user]);

  return {
    data: collectionData,
    isFetching: isDataFetching,
  };
};

export default useFirebaseData;
